import Weight from './Weight';

export default Weight;
